import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: ProductQuantityBreakPricingStyles;
}

export interface ProductQuantityBreakPricingStyles {
    viewLink?: LinkPresentationProps;
    table?: DataTableProps;
    tableHead?: DataTableHeadProps;
    breakQtyHeader?: DataTableHeaderProps;
    breakPriceHeader?: DataTableHeaderProps;
    savingsHeader?: DataTableHeaderProps;
    tableBody?: DataTableBodyProps;
    tableRow?: DataTableRowProps;
    breakQtyCell?: DataTableCellBaseProps;
    breakPriceCell?: DataTableCellBaseProps;
    savingsCell?: DataTableCellBaseProps;
    priceWrapper?: InjectableCss;
    priceWrapperHeading?: InjectableCss;
}

export const productQuantityBreakPricingStyles: ProductQuantityBreakPricingStyles = {
    breakQtyHeader: { alignX: "center" },
    breakPriceHeader: { alignX: "center" },
    savingsHeader: { alignX: "center" },
    breakQtyCell: {
        alignX: "center",
        css: css`
            color: #333F48;
            font-family: Roboto;
            font-size: .9375rem;
            letter-spacing: .011rem;
            line-height: 1.4375rem;
            span {
                color: #333F48;
                font-family: Roboto;
                font-size: .9375rem;
                letter-spacing: .011rem;
                line-height: 1.4375rem;
                display: inline-block;
                vertical-align: middle;

                &:before {
                    content: '+';
                    display: inline-block;
                    vertical-align: middle;
                }
            }
           
        `,
    },
    breakPriceCell: {
        alignX: "center",
        css: css`
            color: #535E64;
            font-family: Roboto;
            font-size: .9375rem;
            letter-spacing: .011rem;
            line-height: 1.4375rem;
        `,
    },
    savingsCell: { alignX: "center" },
    tableRow: {
        css: css`
            background-color: transparent;
        `,
    },
    tableHead: {
        css: css`
            display: none !important;
        `,
    },
    table: {
        css: css`
            
            tr {
                background: transparent !important;
                
                th {
                    display: none !important;
                }
                td, th {
                    background: transparent !important;
                    padding: 0 !important;
                    height: auto !important;
                    border: none !important;
                    text-align: left;
                    min-width: 2.5rem;    
                }
            }
            @media screen and (min-width: 1440px) {
                margin-top: 3.125rem;

                td:first-child {
                    text-align: left;
                }
                td:last-child {
                    text-align: right;
                    span {
                        margin-right: .31250625rem;
                    }
                    
                }
            }
            @media screen and (max-width: 1399px) {
                margin-top: 1.25rem;
            }
        `,
    },
    viewLink: {
        css: css`
            @media screen and (min-width: 1400px) {
                display: none;
            }
            @media screen and (max-width: 1440px) {
                margin: .250625rem 0;
                display: block;
                width: 100%;
                position: relative;
                left: 0;
                text-align: right;
                color: #002554;
                font-family: Lato;
                font-size: .875rem;
                letter-spacing: 0;
                line-height: 1rem;
                text-decoration: underline;
                text-underline-offset:.2rem;
                word-break: break-word;
                white-space: normal;
                    > span {
                        color: #002554 !important; 
                        &:hover {
                            color:#2060AD !important;
                        }
                    }
            }
            @media screen and (max-width: 1279px) {
                margin: .250625rem 0;
                display: inline-block;
                width: auto;
                position: absolute;
                right: 0;
                text-align: right;
                color: #002554;
                font-family: Roboto;
                font-size: .875rem;
                letter-spacing: 0;
                line-height: 1rem;
            }
        `,
    },
    priceWrapperHeading: {
        css: css`
            position: relative;
            color: #002554;
            font-family: Roboto;
            font-size: 1.125rem;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 1.9375rem;
            position: relative;

            &:after {
                height: .1875rem;
                width: .665rem;
                background-color: #C63527;
                content: '';
                display: inline-block;
                position: absolute;
                bottom: -.125rem;
                left: .0625rem;
            }
        `,
    },
    priceWrapper: {
        css: css`
            position: relative;
            @media screen and (max-width: 1440px) {
                display: none;
                width: 13.6875rem;
                background-color: #fff;
                box-shadow: 4px 6px 20px 0px rgba(0,0,0,.18);
                padding: 1.125rem 2.125rem;
                position: absolute;
                z-index: 9;
                bottom: auto;
                right: -2rem;
                top: -90%;

                &:after {
                    content: '';
                    display: block;
                    height: 0;
                    position: absolute;
                    width: 0;
                    border: 12px solid;
                    border-color: #fff transparent transparent transparent;
                    z-index: 99;
                    bottom: -1.438rem;
                    right: 2.813rem;
                }
                

                &.active {
                    display: block;
                }
            }



            @media screen and (max-width: 1279px) {
                display: none;
                width: 13.6875rem;
                background-color: #fff;
                box-shadow: 4px 6px 20px 0px rgba(0,0,0,.18);
                padding: 1.125rem 2.125rem;
                position: absolute;
                z-index: 9;
                bottom: auto;
                top: -100%;
                right: 2.25rem;

                &:after {
                    content: '';
                    display: block;
                    height: 0;
                    position: absolute;
                    width: 0;
                    border: 12px solid;
                    border-color: #fff transparent transparent transparent;
                    z-index: 99;
                    bottom: -1.438rem;
                    right: 2.813rem;
                }
                

                &.active {
                    display: block;
                }
            }
            @media screen and (min-width: 768px) and (max-width: 1023px) { 
                top: -91% !important;
            }
        `,
    },
};

const ProductQuantityBreakPricing: FC<OwnProps & HasProduct> = ({
    product,
    productInfo: { pricing },
    extendedStyles,
}) => {

    const [showText, setShowText] = React.useState(false);

    const [styles] = React.useState(() => mergeToNew(productQuantityBreakPricingStyles, extendedStyles));

    if (
        !product ||
        product.quoteRequired ||
        !pricing ||
        !pricing.unitRegularBreakPrices ||
        pricing.unitRegularBreakPrices.length < 2
    ) {
        return null;
    }

    if (pricing.unitNetPrice <= 0) {
        return null;
    }

    const clickEvent = (event: any) => {
        const linkElement = event.target.parentElement;
        let popupElement = event.target.parentElement;

        while (popupElement.tagName !== 'DIV') {
            popupElement = popupElement.parentElement;
            if (!popupElement) { break; }
        }

        if (linkElement.getAttribute('id') !== `volume-price-link-id-${product.id}` &&
            event.target.getAttribute('id') !== `volume-price-id-${product.id}` &&
            popupElement.getAttribute('id') !== `volume-price-id-${product.id}`
        ) {
            setShowText(false)
            document.removeEventListener('click', clickEvent)
        }
    }

    return (
        <>
            <Typography as='div' {...styles.priceWrapper} id={`volume-price-id-${product.id}`} className={`price-wrapper ${showText ? 'active' : ''}`} >
                <Typography as='h5' {...styles.priceWrapperHeading} className="price-subheading">{translate("Volume Pricing")} </Typography>
                <DataTable {...styles.table}>
                    <DataTableHead {...styles.tableHead}>
                        <DataTableHeader {...styles.breakQtyHeader}>{translate("Min Qty")}</DataTableHeader>
                        <DataTableHeader {...styles.breakPriceHeader}>{translate("Price Per")}</DataTableHeader>
                    </DataTableHead>
                    <DataTableBody {...styles.tableBody}>
                        {pricing!.unitRegularBreakPrices!.map(breakPrice => (
                            <DataTableRow
                                {...styles.tableRow}
                                key={breakPrice.breakQty}
                                data-test-selector="breakPriceRow"
                            >
                                <DataTableCell {...styles.breakQtyCell} data-test-selector="breakQty">
                                    <span>{breakPrice.breakQty}</span>
                                </DataTableCell>
                                <DataTableCell {...styles.breakPriceCell} data-test-selector="price">
                                    {breakPrice.breakPriceDisplay}
                                </DataTableCell>
                            </DataTableRow>
                        ))}
                    </DataTableBody>
                </DataTable>
            </Typography>
            <Link {...styles.viewLink} id={`volume-price-link-id-${product.id}`}
                onClick={() => {
                    setShowText(!showText);
                    document.addEventListener('click', clickEvent)
                }} className="show-price-link">
                {translate("Show volume pricing")}
            </Link>
        </>
    );
};

export default withProduct(ProductQuantityBreakPricing);